import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tu_arrow_top",
  "use": "icon-tu_arrow_top-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol viewBox=\"0 0 34 34\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tu_arrow_top\">\n<rect width=\"32\" height=\"31.7831\" rx=\"15.8915\" transform=\"matrix(-1 0 0 1 33 0.740234)\" stroke=\"#E9EDF3\" />\n<path d=\"M22.468 19.1445L17.4999 14.1426L12.5319 19.1445\" stroke=\"#81818A\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol